module.exports = __webpack_public_path__ + "static/img/user-login.2d852a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/user-login.png
// module id = Fh/m
// module chunks = 1